// By default, strip out thunks
const THUNK_ACTION_REGEXP = /\/(fulfilled|pending|rejected)$/;
export const stripPayload = (s) => ({ type: s.type });
export const DEFAULT_COMBINED_ACTION_TRANSFORMER = (a) => THUNK_ACTION_REGEXP.test(a.type) ? stripPayload(a) : a;
const DEFAULT_SLICE_ACTION_TRANSFORMER = (a) => a;
/**
 * Create a transformer from a slice and a transform function. Also takes an
 * optional action transform function. Returns a cached slice transformer.
 *
 * @param slice Slice to transform
 * @param stateTransformer Function that takes in the slice state and returns transformed state
 * @param actionTransformer Optional function that transforms actions.
 */
export const createSliceTransformer = (slice, stateTransformer, actionTransformer = DEFAULT_SLICE_ACTION_TRANSFORMER) => {
    let prevState = {};
    let transformedState = {};
    return {
        name: slice.name,
        transformAction: actionTransformer,
        transformState: (state) => {
            if (state == null)
                return state;
            if (state !== prevState) {
                transformedState = stateTransformer(state);
                prevState = state;
            }
            return transformedState;
        },
    };
};
export const combineActionTransformers = (transformers) => (action) => {
    let transformedAction = action;
    for (const transformer of transformers) {
        // Return the transformed action when we get a value different from the original action
        if ((transformedAction = transformer(transformedAction)) !== action)
            return transformedAction;
    }
    return transformedAction;
};
export const combineTransformers = (transformers, actionTransformer = DEFAULT_COMBINED_ACTION_TRANSFORMER) => {
    let prevState = {};
    let transformedState = {};
    return {
        transformAction: combineActionTransformers([
            actionTransformer,
            ...transformers.map((t) => t.transformAction),
        ]),
        transformState: (state) => {
            if (!state)
                return state;
            if (state !== prevState) {
                transformedState = transformers.reduce((ts, transformObj) => {
                    const sliceName = transformObj.name;
                    ts[sliceName] = transformObj.transformState(state[sliceName]);
                    return ts;
                }, {});
                prevState = state;
            }
            return transformedState;
        },
    };
};
export const createReduxTransformer = (transformer, sideEffectsCb, onError) => (next) => (reducer, preloadedState) => {
    const transformSideEffectsReducer = (s, a) => {
        const newState = reducer(s, a);
        try {
            const transformedAction = transformer.transformAction(a);
            const transformedState = transformer.transformState(newState);
            sideEffectsCb(transformedAction, transformedState);
        }
        catch (e) {
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
        return newState;
    };
    return next(transformSideEffectsReducer, preloadedState);
};
//# sourceMappingURL=index.js.map